import { render } from "./DeleteFolder.vue?vue&type=template&id=3de2b900"
import script from "./DeleteFolder.vue?vue&type=script&lang=js"
export * from "./DeleteFolder.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__